export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7931.cc41ccc7.jpg";